import { TranslocoPipe, provideTranslocoScope } from '@jsverse/transloco';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { NonOil, Oil } from 'customers';

export interface CustomerCodesDialogData {
  ragioneSociale: string;
  oil: Oil[];
  nonOil: NonOil[];
  // Codici da preselezionare e codici utilizzati per ultimi
  initialOil?: string | null;
  initialNonOil?: string | null;
  lastUsed?: string[];
}

export interface CustomerCodesDialogResult {
  oilCode: string | null;
  nonOilCode: string | null;
}

@Component({
  providers: [provideTranslocoScope('orders')],
  selector: 'ord-customer-codes-dialog',
  imports: [TranslocoPipe, MatButtonModule, MatDialogModule],
  templateUrl: './customer-codes-dialog.html',
  styleUrl: './customer-codes-dialog.scss',
})
export class CustomerCodesDialog {
  private readonly dialogRef = inject<MatDialogRef<CustomerCodesDialog, CustomerCodesDialogResult>>(MatDialogRef);
  readonly data = inject<CustomerCodesDialogData>(MAT_DIALOG_DATA);

  // Un codice unico è già selezionato: l'utente sceglie solo dove c'è ambiguità.
  oilCode: string | null = this.data.oil.find(item => item.codice === this.data.initialOil)?.codice
    ?? (this.data.oil.length === 1 ? this.data.oil[0].codice : null);
  nonOilCode: string | null = this.data.nonOil.find(item => item.codice === this.data.initialNonOil)?.codice
    ?? (this.data.nonOil.length === 1 ? this.data.nonOil[0].codice : null);

  isLastUsed(codice: string): boolean {
    return this.data.lastUsed?.includes(codice) ?? false;
  }

  get canConfirm(): boolean {
    const oilOk = this.data.oil.length === 0 || this.oilCode !== null;
    const nonOilOk = this.data.nonOil.length === 0 || this.nonOilCode !== null;
    return oilOk && nonOilOk;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    if (!this.canConfirm) {
      return;
    }

    this.dialogRef.close({ oilCode: this.oilCode, nonOilCode: this.nonOilCode });
  }
}
